import { useDispatch, useSelector } from "react-redux";
import { useState, useContext, useRef, useEffect } from "react";
import { fetchProfilPrestataire } from "../../redux/actions/profilActions";
import { GoogleMapsContext } from "../../context/GoogleMapsProvider";
import GoogleAddressSearch from "../GoogleAddressSearch";



// Formulaire principal
const FormModalUpdateLocalisationPresta = ({ onClose }) => {
  const { token } = useSelector((state) => state.auth);
  const profilPrestataire = useSelector((state) => state.profil.prestataire);
  const dispatch = useDispatch();
  const { isLoaded } = useContext(GoogleMapsContext);
  const apiUrl = process.env.REACT_APP_API_URL;

  const [errors, setErrors] = useState({});
  const [updateSuccess, setUpdateSuccess] = useState(false);

  const [formData, setFormData] = useState({
    companyAddress: profilPrestataire.adressePrestataire || "",
    companyPostalCode: profilPrestataire.codePostalPrestataire || "",
    companyCity: profilPrestataire.villePrestataire || "",
    companyCountry: "fr",
    travailDistance: profilPrestataire.isDistanceOnly || false,
    rayonIntervention: profilPrestataire.rayonIntervention || "",
  });

  // Validation
  const validateField = (name, value) => {
    let fieldErrors = { ...errors };
    switch (name) {
      case "companyAddress":
        if (!value || value.length < 5) fieldErrors.companyAddress = "L'adresse est obligatoire";
        else delete fieldErrors.companyAddress;
        break;
      case "companyPostalCode":
        if (!value) fieldErrors.companyPostalCode = "Le code postal est obligatoire";
        else if (!/^(?:0[1-9]|[1-8]\d|9[0-5])\d{3}$/.test(value))
          fieldErrors.companyPostalCode = "Code postal français invalide";
        else delete fieldErrors.companyPostalCode;
        break;
      case "companyCity":
        if (!value || value.length < 2) fieldErrors.companyCity = "La ville doit contenir 2 caractères minimum";
        else delete fieldErrors.companyCity;
        break;
      case "rayonIntervention":
        if (!formData.travailDistance && !value) fieldErrors.rayonIntervention = "Sélectionnez un rayon";
        else delete fieldErrors.rayonIntervention;
        break;
    }
    setErrors(fieldErrors);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;
    if (name === "rayonIntervention") newValue = parseInt(value, 10);

    setFormData((prev) => ({ ...prev, [name]: newValue }));
    validateField(name, newValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(errors).length > 0) {
      alert("Veuillez corriger les erreurs.");
      return;
    }

    try {
      const form = new FormData();
      Object.keys(formData).forEach((key) => form.append(key, formData[key]));

      const response = await fetch(`${apiUrl}/api/updateProfil/prestataire`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.message || "Erreur lors de la mise à jour.");
        return;
      }

      await response.json();
      setUpdateSuccess(true);
      dispatch(fetchProfilPrestataire(token));
      setTimeout(onClose, 800);
    } catch (error) {
      console.error("Erreur :", error);
      alert("Impossible de contacter le serveur.");
    }
  };

  // Fonction pour remplir adresse, code postal et ville depuis Google Place
  const handlePlaceSelect = (place) => {
    const components = place.address_components || [];
    let streetNumber = "", route = "", postal = "", city = "";

    components.forEach((c) => {
      if (c.types.includes("street_number")) streetNumber = c.long_name;
      if (c.types.includes("route")) route = c.long_name;
      if (c.types.includes("postal_code")) postal = c.long_name;
      if (c.types.includes("locality")) city = c.long_name;
      if (!city && c.types.includes("administrative_area_level_2")) city = c.long_name;
    });


    setFormData((prev) => ({
      ...prev,
      companyAddress: [streetNumber, route].filter(Boolean).join(" "),
      companyPostalCode: postal,
      companyCity: city,
    }));

    validateField("companyAddress", [streetNumber, route].filter(Boolean).join(" "));
    validateField("companyPostalCode", postal);
    validateField("companyCity", city);
  };

  const isStepValid =
    !errors.companyAddress &&
    !errors.companyPostalCode &&
    !errors.companyCity &&
    formData.companyAddress &&
    formData.companyPostalCode &&
    formData.companyCity &&
    (formData.travailDistance || (!!formData.rayonIntervention && !errors.rayonIntervention));

  return (
    <div className="inscriptionModalOverlay">
      <div className="inscriptionModal">
        <button className="inscriptionModalClose" onClick={onClose}>×</button>

        <form onSubmit={handleSubmit}>
          <h2>Localisation de l'entreprise et rayon d'intervention</h2>

          <div className="inscriptionPrestataireModal-input-form">
            <label>Rechercher une adresse</label>
            {isLoaded && (
              <GoogleAddressSearch
                defaultValue={formData.companyAddress + ", " + formData.companyPostalCode + " " + formData.companyCity}
                onSelect={handlePlaceSelect}
              />
            )}
          </div>

          <div className="inscriptionPrestataireModal-input-form">
            <label>
              <input
                type="checkbox"
                name="travailDistance"
                checked={formData.travailDistance}
                onChange={handleChange}
              />
              Je propose mes services uniquement à distance
            </label>
          </div>

          {!formData.travailDistance && (
            <div className="inscriptionPrestataireModal-input-form">
              <label>Rayon d'intervention</label>
              <select
                name="rayonIntervention"
                value={formData.rayonIntervention ?? ""}
                onChange={handleChange}
                required
              >
                <option value="">-- Sélectionnez un rayon --</option>
                <option value="5">5 km</option>
                <option value="10">10 km</option>
                <option value="20">20 km</option>
                <option value="50">50 km</option>
                <option value="100">100 km</option>
                <option value="200">200 km</option>
                <option value="1000000">Illimité</option>
              </select>
            </div>
          )}

          <div className="inscriptionClientModal-actions">
            <button type="submit" disabled={!isStepValid}>ENREGISTRER</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormModalUpdateLocalisationPresta;
